import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationModalComponent } from './translation-modal.component';
import { CreateTranslationComponent } from './create-translation/create-translation.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationWarningComponent } from './translation-warning/translation-warning.component';
import { SwitchLanguageBtnComponent } from './switch-language-btn/switch-language-btn.component';

@NgModule({
  imports: [CommonModule, TranslateModule, IonicModule, ReactiveFormsModule, FormsModule],
  declarations: [TranslationModalComponent, CreateTranslationComponent, TranslationWarningComponent, SwitchLanguageBtnComponent],
  exports: [TranslationModalComponent, CreateTranslationComponent, TranslationWarningComponent, SwitchLanguageBtnComponent],
  entryComponents: [TranslationModalComponent, CreateTranslationComponent, TranslationWarningComponent, SwitchLanguageBtnComponent]
})
export class TranslationModalModule {}
